import {useEffect} from 'react';

import {useLocation, useNavigate} from 'react-router-dom';

import useInterval from '@common/hooks/useInterval';
import {MAIN_JWT_REFRESH_DELAY} from '@common/constants/authentication/authenticationConstants';
import {getMainJwt, checkJwt, cleanCredentialsFromUrl, clearMainJwtFromStorage} from '@common/helpers/authentication/authenticationHelper';
import useAuthenticationStore from '@common/stores/authenticationStore';

export const useAuthentication = () => {
  const {isAuthenticated, mainJwt, refreshMainJwt, authenticate, finaliseAuthenticate} = useAuthenticationStore();
  const location = useLocation();
  const navigate = useNavigate();
  const externalMainJwt = getMainJwt(location);

  useInterval(() => {
    if (mainJwt) {
      refreshMainJwt();
    }
  }, MAIN_JWT_REFRESH_DELAY);

  useEffect(() => {
    if (isAuthenticated) {
      cleanCredentialsFromUrl(location, navigate);
    }
  }, [isAuthenticated, location, navigate]);

  useEffect(() => {
    if (!isAuthenticated) {
      if (externalMainJwt && checkJwt(externalMainJwt as string)) {
        finaliseAuthenticate(externalMainJwt as string);
      } else {
        clearMainJwtFromStorage();
        authenticate();
      }
    }
  }, [isAuthenticated, externalMainJwt, finaliseAuthenticate, authenticate]);

  return isAuthenticated;
};
